import React from 'react';
import Link from 'gatsby-link';
import styles from './styles.module.css';

import BackgroundContainer from '../background-container';
import ArrowIcon from '../../icons/Arrow';

export default ({ id, to, onClick, imageSrc, title, text }) => {
  const Tag = onClick ? 'button' : Link;

  return (
    <Tag id={id} to={to} onClick={onClick} className={styles.container}>
      <BackgroundContainer src={imageSrc}>
        <div className={styles.inner}>
          <p className={styles.title}>{title}</p>
          <p className={styles.text}>{text}</p>
        </div>
        <ArrowIcon color="#fff" size={32} direction="right" />
      </BackgroundContainer>
    </Tag>
  );
};



// WEBPACK FOOTER //
// ./src/components/tile-link/index.js